import type { CSSProperties } from 'react';
import { clsx } from 'clsx';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  '@keyframes accordionExpand': {
    from: {
      height: '50%',
      width: 300,
    },
    to: {
      height: '70%',
      width: '85%',
    },
  },

  '@keyframes accordionShrink': {
    from: {
      height: '70%',
      width: '85%',
    },
    to: {
      height: '50%',
      width: 300,
    },
  },

  expando: (props: CSSProperties & { isExpanding?: boolean }) => ({
    overflow: 'hidden',
    position: 'absolute',
    inset: props.inset,
    width: props.width,
    // Only apply minHeight during expansion/shrinking, otherwise auto-size to content
    minHeight: props.isExpanding ? props.minHeight : 'auto',
    height: props.isExpanding ? undefined : 'auto',
    boxSizing: 'border-box',
    borderRadius: 12.5,
    pointerEvents: 'none', // Let clicks pass through container
  }),

  accordionExpand: {
    animation: `$accordionExpand 0.5s ease-out forwards`,
  },

  accordionShrink: {
    animation: '$accordionShrink 0.5s ease-out forwards',
  },
});

type Props = {
  width: number;
  inset?: string | number;
  minHeight: string;
  children: JSX.Element | JSX.Element[];
  expand: boolean | null;
};

export function ExpandoBox(props: Props) {
  const { children, expand = null, width, minHeight, inset = 0 } = props;
  // Only apply fixed height when expanding/shrinking
  const isExpanding = expand !== null;
  const classes = useStyles({ width, minHeight, inset, isExpanding });
  return (
    <div
      className={clsx(
        classes.expando,
        { [classes.accordionExpand]: expand === true },
        { [classes.accordionShrink]: expand === false && expand != null },
      )}
    >
      {children}
    </div>
  );
}
